__turbopack_context__.v({
  "actions": "PreAnalysisModal-module__cSrHca__actions",
  "cancel": "PreAnalysisModal-module__cSrHca__cancel",
  "card": "PreAnalysisModal-module__cSrHca__card",
  "close": "PreAnalysisModal-module__cSrHca__close",
  "head": "PreAnalysisModal-module__cSrHca__head",
  "overlay": "PreAnalysisModal-module__cSrHca__overlay",
  "proceed": "PreAnalysisModal-module__cSrHca__proceed",
  "row": "PreAnalysisModal-module__cSrHca__row",
  "rowLabel": "PreAnalysisModal-module__cSrHca__rowLabel",
  "thumb": "PreAnalysisModal-module__cSrHca__thumb",
  "thumbDur": "PreAnalysisModal-module__cSrHca__thumbDur",
  "title": "PreAnalysisModal-module__cSrHca__title",
});
